module.exports = __webpack_public_path__ + "static/media/iphone_12_black.388de382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_black.png
// module id = 2088
// module chunks = 0